import { CellCoordinates, CellMetaData } from 'components/common-form/builder/form/node/field/Grid/GridField.model';
import { CellId } from 'models/batch/navigation';
import { UnderlyingCodeType } from 'models/underlying/base';
import { createContext, KeyboardEvent, useContext, useEffect, useState } from 'react';

export type BatchNavigationContextValue = {
  setSelectedCell?: (cellCoordinates: CellCoordinates | undefined) => void;
  setLostInputBeforeEditing?: (input: string | undefined) => void;
  setIsEditing?: (isEditing: boolean) => void;
  onNavigationKeyDown?: (e: KeyboardEvent, canEdit: boolean) => void;
  onEditingKeyDown?: (e: KeyboardEvent) => void;
  addGridRef?: (cellId: string, cellMetadata: CellMetaData) => void;
  onEditionCompleted?: () => void;
  setIsSelectAll?: (isSelectAll: boolean) => void;
  lostInputBeforeEditing?: string;
  selectedCellId?: CellId;
  isEditing?: boolean;
  isSelected?: boolean;
  isCellInactive?: boolean;
  isFocused?: boolean;
  isSelectAll?: boolean;
  defaultUnderlyingCodeType?: UnderlyingCodeType;
};

export const BatchNavigationContext = createContext<BatchNavigationContextValue>({});

interface Options {
  decimalPadding?: boolean;
}
export const useBatchNavigationContext = ({ decimalPadding }: Options) => {
  const { isFocused, ...ctx } = useContext(BatchNavigationContext);
  const [padding, setDecimalPadding] = useState<boolean | undefined>(decimalPadding);
  useEffect(() => {
    if (isFocused) {
      setDecimalPadding(false);
    } else {
      setDecimalPadding(decimalPadding);
    }
  }, [isFocused, decimalPadding]);
  return { decimalPadding: padding, isFocused, ...ctx };
};
